import { insertNodes } from '@udecode/plate-common';
import { createPlatePlugin } from '@udecode/plate-common/react';
import { v4 as uuid } from 'uuid';

import { ELEMENTS_WITH_MANDATORY_EMPTY_LINE_AFTER } from '@/component/customEditorV2/ui/elements/SlashInputElement/transforms';

const makeParagraphNode = () => ({ type: 'paragraph', id: uuid(), children: [{ text: '' }] });

export const TrailingParagraphPlugin = createPlatePlugin({
  key: 'trailing-paragraph',
  normalizeInitialValue: (ctx) => {
    const editorNodes = ctx.value;
    if (!editorNodes.length) return editorNodes;

    const lastNode = editorNodes[editorNodes.length - 1];
    if (lastNode && ELEMENTS_WITH_MANDATORY_EMPTY_LINE_AFTER.includes(lastNode.type as string)) {
      return [...editorNodes, makeParagraphNode()];
    }

    return editorNodes;
  },
  extendEditor: (ctx) => {
    const { normalizeNode } = ctx.editor;

    ctx.editor.normalizeNode = ([node, path]) => {
      if (path.length === 0) {
        const lastChild = ctx.editor.children[ctx.editor.children.length - 1];
        if (
          lastChild &&
          ELEMENTS_WITH_MANDATORY_EMPTY_LINE_AFTER.includes((lastChild as Record<string, unknown>).type as string)
        ) {
          insertNodes(ctx.editor, makeParagraphNode(), { at: [ctx.editor.children.length] });

          return;
        }
      }

      normalizeNode([node, path]);
    };

    return ctx.editor;
  },
});
